import { UrlParam } from '@/lib/url/url-param.hook'
import { buildQuestionnairePortalUrl } from '@/lib/url/urls'

import { useToast } from '@/components/lemmala-design-system/toast/use-toast'

export const useCopyQuestionnaireLink = () => {
  const { toast } = useToast()

  const copyQuestionnaireLink = (companyId: string, questionnaireId: string) => {
    const questionnairePath = buildQuestionnairePortalUrl(
      companyId,
      {
        [UrlParam.RECIPIENT_QUESTIONNAIRE]: questionnaireId,
      },
      { absolute: true },
    )

    navigator.clipboard.writeText(questionnairePath)

    toast({
      title: 'Copied to clipboard',
      variant: 'success',
    })
  }

  return { copyQuestionnaireLink }
}
